import { SearchBoxState, StandaloneSearchBoxState } from '@coveo/headless';
import { IconButton, IconSearch } from '@lmig/lmds-react-icons';
import { AlphanumericInput } from '@lmig/lmds-react-alphanumeric-input';
import { useState } from 'react';

interface ISearchSuggestionInput {
  label: string;
  state: StandaloneSearchBoxState | SearchBoxState;
  onChange: Function;
  onSubmit: Function;
  onSuggestionClick: Function;
  showSearchIcon?: boolean;
  showSuggestions?: boolean;
  autoFocus?: boolean;
}
export function SearchSuggestionInput({
  state,
  onChange,
  onSubmit,
  onSuggestionClick,
  showSearchIcon = false,
  showSuggestions = true,
  label,
  autoFocus = false,
}: ISearchSuggestionInput) {
  const [suggestionsVisible, setSuggestionsVisible] = useState(true);
  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      setSuggestionsVisible(false);
      onSubmit();
    }
  };
  const iconClick = () => {
    onSubmit();
  };
  return (
    <>
      <div className="search-input-suggestion-wrapper" data-theme="evolved">
        <div className="search-input-wrapper">
          <AlphanumericInput
            labelVisual={label}
            value={state.value}
            onChange={(e) => onChange(e.target.value)}
            onKeyDown={(e) => onKeyDown(e)}
            onFocus={() => setSuggestionsVisible(true)}
            onBlur={() => setSuggestionsVisible(false)}
            type="search"
            autoFocus={autoFocus}
            className="search-input"
          />
          {showSearchIcon && (
            <div onClick={iconClick} className="standalone-search-icon-wrapper">
              <IconButton background="transparent">
                <IconSearch title="Search" aria-hidden="false" size="16" />
              </IconButton>
            </div>
          )}
        </div>
        {showSuggestions && suggestionsVisible && state.suggestions.length > 0 && state.value.length !== 0 && (
          <div className="search-suggest" role="listbox">
            <div className="search-suggest-content">
              <ul className="search-suggest-list">
                {state.suggestions.map((suggestion) => {
                  const value = suggestion.rawValue;
                  return (
                    <li
                      key={value}
                      onMouseDown={() => {
                        onSuggestionClick(value);
                      }}
                      className="search-suggest-list-item"
                      aria-label={typeof suggestion === 'object' ? suggestion.rawValue : suggestion}
                    >
                      {value}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
